export const BadgePremiseType = (props) => {
  // input
  const { type = null} = props;

  switch(type) {
    // residential
    case 'terrace': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 shadow-sm ring-1 ring-inset ring-green-500/10">
        Terrace
      </span>
    )
    case 'highrise': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 shadow-sm ring-1 ring-inset ring-green-500/10">
        High-rise
      </span>
    )
    case 'semid': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 shadow-sm ring-1 ring-inset ring-green-500/10">
        Semi Detach
      </span>
    )
    case 'bungalow': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 shadow-sm ring-1 ring-inset ring-green-500/10">
        Bungalow
      </span>
    )

    // commercial
    case 'hotel': return (
      <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600 shadow-sm ring-1 ring-inset ring-blue-500/10">
        Hotel
      </span>
    )
    case 'shrine': return (
      <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600 shadow-sm ring-1 ring-inset ring-blue-500/10">
        Shrine
      </span>
    )
    case 'office': return (
      <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600 shadow-sm ring-1 ring-inset ring-blue-500/10">
        Office
      </span>
    )
    case 'shoplot': return (
      <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600 shadow-sm ring-1 ring-inset ring-blue-500/10">
        Shop Lot
      </span>
    )

    // unique
    case 'factory': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-500/10">
        Factory
      </span>
    )
    case 'warehouse': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-500/10">
        Warehouse
      </span>
    )
    case 'school': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-500/10">
        School
      </span>
    )
    case 'hospital': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-500/10">
        Hospital
      </span>
    )
    case 'mosque': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-500/10">
        Mosque
      </span>
    )
    case 'hall': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-500/10">
        Hall
      </span>
    )
    case 'gasstation': return (
      <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-600 shadow-sm ring-1 ring-inset ring-yellow-500/10">
        Petrol Station
      </span>
    )
    default: return (
      <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 shadow-sm ring-1 ring-inset ring-gray-500/10">
        {type ? type : 'Unknown'}
      </span>
    )
  }
}